<div [class]="iconClass" [ngStyle]="{ color: color }"></div>
<div [class]="labelClass" [ngStyle]="{ color: color }">{{ label }}</div>
